<template>
  <div class="box">
    <el-form :model="info" label-position="right" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm" size="small">
      <el-form-item label="优惠券名称" prop="title">
        <el-input v-model="info.title" placeholder="请输入优惠券名称"></el-input>
      </el-form-item>
      <el-form-item label="发放方式" prop="send_type">
        <el-radio-group v-model="info.send_type">
          <el-radio :label="1">用户领取</el-radio>
          <el-radio :label="2">系统发放</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="优惠券类型" prop="coupon_type">
        <el-radio-group v-model="info.coupon_type" :disabled="info.sale_sum>0">
          <el-radio :label="1">现金券</el-radio>
          <el-radio :label="2">折扣券</el-radio>
          <el-radio :label="3">实物券
            <el-tooltip class="item" effect="dark" content="仅线下核销使用" placement="top-start">
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
            </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="" prop="coupon_val" v-if="info.coupon_type==1">
        <el-input v-model="info.coupon_val" placeholder="请输入金额" :disabled="info.sale_sum>0">
          <template slot="prepend">抵</template>
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="" prop="coupon_val" v-if="info.coupon_type==2">
        <el-input v-model="info.coupon_val" placeholder="请输入折扣" :disabled="info.sale_sum>0">
          <template slot="prepend">打</template>
          <template slot="append">折：填0~100，80代表8折</template>
        </el-input>
      </el-form-item>
      <el-form-item label="" prop="goods_name" v-if="info.coupon_type==3">
        <el-input v-model="info.goods_name" placeholder="请输入商品名称"></el-input>
      </el-form-item>
      <el-form-item label="满减条件" prop="is_condition">
        <el-radio-group v-model="info.is_condition" :disabled="info.sale_sum>0">
          <el-radio :label="0">不限制</el-radio>
          <el-radio :label="1">限制</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="" prop="condition_val" v-if="info.is_condition==1">
        <el-input v-model="info.condition_val" placeholder="请输入金额" :disabled="info.sale_sum>0">
          <template slot="prepend">满</template>
          <template slot="append">元使用（不含运费）</template>
        </el-input>
      </el-form-item>
      <el-form-item label="生效时间" prop="time_type">
        <el-radio-group v-model="info.time_type" :disabled="info.sale_sum>0">
          <el-radio :label="1">指定时间</el-radio>
          <el-radio :label="2">固定时间</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="" v-if="info.time_type==1">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-input v-model="info.start_day" placeholder="请输入天数" :disabled="info.sale_sum>0">
              <template slot="prepend">领取</template>
              <template slot="append">天后生效</template>
            </el-input>
          </el-col>
          <el-col :span="12">
            <el-input v-model="info.end_day" placeholder="请输入天数" :disabled="info.sale_sum>0">
              <template slot="prepend">领取</template>
              <template slot="append">天后失效</template>
            </el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="" prop="title" v-if="info.time_type==2">
        <el-date-picker :disabled="info.sale_sum>0"
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="发放数量" prop="sum">
        <el-input v-model="info.sum" placeholder="请输入数量">
          <template slot="append">张</template>
        </el-input>
      </el-form-item>
      <el-form-item label="适用范围" prop="goods_type">
        <el-radio-group v-model="info.goods_type">
          <el-radio :label="1">全部商品</el-radio>
          <el-radio :label="2">商品分类</el-radio>
          <el-radio :label="3">部分商品</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="" v-if="info.goods_type==2">
        <el-select v-model="info.goods_ids" placeholder="请选择" multiple style="width: 100%">
          <el-option
              v-for="item in menuList"
              :key="item.id"
              :label="item.title"
              :disabled="item.pid==0"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="" v-if="info.goods_type==3">
        <el-button type="primary" @click="showModal=true">选择商品</el-button>
        <div class="goods-box">
          <draggable v-model="info.goods" :options="bottomNavOptions">
            <div class="item" v-for="(item,index) in info.goods" :key="index">
              <img :src="item.img" class="img" />
              <div class="name">{{ item.title }}</div>
              <div class="close" title="删除商品" @click="delGoods(index)"><i class="el-icon-error"></i></div>
            </div>
          </draggable>
        </div>
      </el-form-item>
      <el-form-item label="领取限制" prop="get_type">
        <el-radio-group v-model="info.get_type">
          <el-radio :label="0">不限制</el-radio>
          <el-radio :label="1">限制</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="" prop="get_limit" v-if="info.get_type==1">
        <el-input v-model="info.get_limit" placeholder="请输入领取数量">
          <template slot="prepend">每人最多可领取</template>
          <template slot="append">张</template>
        </el-input>
      </el-form-item>
      <el-form-item label="" prop="limit_day_member" v-if="info.get_type==1">
        <el-input v-model="info.limit_day_member" placeholder="请输入领取数量">
          <template slot="prepend">每人每天最多可领取</template>
          <template slot="append">张</template>
        </el-input>
      </el-form-item>
      <el-form-item label="说明">
        <el-input type="textarea" rows="4" v-model="info.remark" placeholder="请输入说明"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <el-button type="button" @click="reBack()">返回</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
        title="选择商品"
        :visible.sync="showModal"
        :destroy-on-close="true"
        width="900px">
      <goods-list :type="2" :selectFunc="chooseGoods"></goods-list>
    </el-dialog>
  </div>
</template>
<script>

import goodsList from "@/components/Goods/GoodsList";
import draggable from 'vuedraggable';
export default {
  data() {
    return {
      showModal: false,
      info: {
        id: 0,
        title: "",
        send_type: 1,
        coupon_type: 1,
        coupon_val: '',
        is_condition: 0,
        start_day: '',
        end_day: '',
        condition_val: '',
        time_type: 1,
        goods_type: 1,
        goods_ids: [],
        goods: [],
        get_type: 0,
        get_limit: '',
        sale_sum: 0,
        limit_day_member: ''
      },
      menuList: [],
      dateRange: ['',''],
      source_domain: this.config.SOURCE_DOMAIN,
      rules: {
        title: [
          { required: true, message: '请输入优惠券名称', trigger: 'blur' }
        ],
        coupon_val: [
          { required: true, message: '金额或者折扣不能为空', trigger: 'blur' }
        ],
        goods_name: [
          { required: true, message: '商品名不能为空', trigger: 'blur' }
        ],
        condition_val: [
          { required: true, message: '满减金额不能为空', trigger: 'blur' }
        ],
        sum: [
          { required: true, message: '发放数量不能为空', trigger: 'blur' }
        ],
        get_limit: [
          { required: true, message: '领取张数不能为空', trigger: 'blur' }
        ],
        limit_day_member: [
          { required: true, message: '领取张数不能为空', trigger: 'blur' }
        ]
      },
      bottomNavOptions: {
        group: {
          name: 'bottomNav',
          pull: true,
          put: true
        },
        sort: true,
        animation: 100
      }
    };
  },
  components: {
    goodsList,
    draggable
  },
  created() {
    this.getMenuList()
    if(this.$route.query.id) {
      this.info.id = this.$route.query.id
      this.getInfo()
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    chooseGoods(goods) {
      var _this = this
      goods.forEach(function (item) {
        _this.info.goods.push({id: item.id, title: item.title, img: item.img, price: item.price})
      })
      _this.showModal = false
    },
    delGoods(idx) {
      this.info.goods.splice(idx,1)
    },
    getMenuList() {
      this.$api.goods.menuIndex({page_size: 100,type:1}, res => {
        if (res.errcode == 0) {
          this.menuList = res.data
        }
      })
    },
    getInfo() {
      this.showLoading()
      this.$api.marking.couponInfo({id: this.info.id}, res => {
        this.hideLoading()
        if(res.errcode == 0) {
          this.info = res.data
          if(this.info.time_type==2) {
            this.dateRange = [this.info.start_time,this.info.end_time]
          }
        } else {
          this.fail(res.errmsg)
        }
      })
    },
    submitForm(formName) {
      var that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var param = that.info
          if(this.info.time_type==2) {
            this.info.start_time = this.dateRange[0]
            this.info.end_time = this.dateRange[1]
          }
          var goodsIds = []
          if(this.info.goods_type==3) {
            this.info.goods.forEach(function (item) {
              goodsIds.push(item.id)
            })
            this.info.goods_ids = goodsIds
          }
          this.$api.marking.couponEdit(param,function (res) {
            if(res.errcode == 0) {
              that.success(res.errmsg)
              that.reBack()
            } else {
              that.fail(res.errmsg)
            }
          })
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style scoped>
  .box {
    background-color: #fff;
    padding: 20px;
    border-radius: 6px;
    min-height: 500px;
  }
  .ruleForm {
    width: 700px;
  }
</style>
